<template>
  <div>
    <div
      padding
    >
      <q-form
        @submit="onSubmit(applicationDetails)"
        class="q-gutter-md flex flex-center q-pa-md"
        ref="applicationPreferenceForm"
        greedy
      >
        <fieldset
          class="q-gutter-md q-mt-md"
          style="max-width: 749px"
        >
          <legend class="text-left text-h5">
            Housing Preferences
          </legend>
          <q-separator />
            <legend
              class="text-left text-body1 q-gutter-md"
            >
            <div style="margin-top: 0px">
              Although we make every effort to accommodate your preferences,
              please note that due to availability of spaces, all preferences
              may not be met upon placement in DigiPen Housing.
            </div>
            <div>
              Visit our <a href="https://www.digipen.edu/campus-life/housing/apply-for-housing" target="_blank">Apply for Housing Page</a>
              for more information about Housing Application Options and FAQ.
            </div>
            <div>
              If your preferences change after submitting your application,
              please contact <a href="mailto:housing@digipen.edu">housing@digipen.edu</a>
              so that edits may be made.
            </div>
          </legend>
        </fieldset>

        <fieldset
          class="q-gutter-md q-mt-md"
          style="max-width: 749px"
        >
          <legend class="text-left text-h6">
            Gender Inclusive Housing
          </legend>
          <q-separator />
          <div class="q-gutter-md">
            <div class="text-left text-body1">
                Would you like to live in Gender Inclusive Housing?
              <q-icon class="cursor-pointer"
                      color="positive"
                      size="sm"
                      name="help_outline">
                <q-tooltip class="text-body2"
                            max-width="377px"
                            anchor="top middle"
                            self="bottom middle"
                            :offset="[10, 10]">
                  <div class="q-ma-sm">
                    Inclusive Housing is an option for students to share a multiple-occupancy
                    apartment, regardless of each student’s sex, gender, gender identity,
                    gender expression, and/or sexual orientation.
                  </div>
                  <div class="q-ma-sm">
                    By selecting this option, you are provided the opportunity to select
                    what Gender Identities (other than your own) that you are comfortable
                    living with.
                  </div>
                  <div class="q-ma-sm">
                    Your preferences will be noted and used for eventual roommate-matching &
                    Housing Placement.
                  </div>
                </q-tooltip>
              </q-icon>
            </div>

            <div class="flex flex-left q-pa-md row">
              <q-radio v-model="applicationDetails.liveWithSameGenders"
                        class="col-12"
                        val="Other"
                        label="Yes, I would like to live in Gender-Inclusive Housing" />
              <q-radio v-model="applicationDetails.liveWithSameGenders"
                        class="col-12"
                        val="Same"
                        label="No, I would like to live with
                        roommates of my same gender identity" />
            </div>
            <div v-if="applicationDetails.liveWithSameGenders == 'Other'">
              <div class="text-left text-body1">
                What Gender Identities are you comfortable living with?
              </div>
              <q-select class="q-mb-lg"
                        v-model="applicationDetails.roommatesGenders"
                        :options="genderList"
                        label="Select Preference(s)"
                        multiple
                        :rules="[checkIsEmptyGenderList]"
                        lazy-rules>
                <template v-slot:option="{ itemProps, opt, selected, toggleOption }">
                  <q-item v-bind="itemProps">
                    <q-item-section>
                      <q-item-label v-html="opt" />
                    </q-item-section>
                    <q-item-section side>
                      <q-toggle :model-value="selected"
                                @update:model-value="toggleOption(opt)" />
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>
            </div>

            <!-- <div class="text-left text-body1">
              <div class="text-left text-body1 q-mb-md">
                Are you interested in participating in a Living Learning Community?
                <q-icon class="cursor-pointer"
                        color="positive"
                        size="sm"
                        name="help_outline">
                  <q-tooltip class="text-body2"
                              max-width="377px"
                              anchor="top middle"
                              self="bottom middle"
                              :offset="[10, 10]">
                    <div class="q-ma-sm">
                      Learn more about our available Living Learning Communities (L.L.C’s) on our
                      <a href="https://www.digipen.edu/campus-life/housing/residential-life" target="_blank">Website</a>.
                    </div>
                    <div class="q-ma-sm">Please note that indicating interest in a Living Learning
                      Community does not guarantee participation. Upon indicating interest,
                      a separate application form will open in a new tab and is required to
                      be completed for consideration. Your Housing Application and Living Learning
                      Community application are reviewed separately.</div>
                    <div class="q-ma-sm">Please email
                      <a href="mailto:housing@digipen.edu">housing@digipen.edu</a>
                      with any questions.
                    </div>
                  </q-tooltip>
                </q-icon>
              </div>
            </div>
            <div class="flex flex-left q-pa-md row">
              <div class="flex flex-left col-12">
                <q-radio v-model="applicationDetails.livingLearningCommunityStatus"
                          val="Requested"
                          label="Rainbow Community"
                          @update:model-value="goToLlcSite()" />
              </div>
              <q-radio v-model="applicationDetails.livingLearningCommunityStatus"
                        class="col-12"
                        val="Waived"
                        label="No, I am not interested in
                        participating in a Living Learning Community" />
            </div> -->
          </div>
        </fieldset>
        <fieldset
          class="flex-center q-gutter-md q-mt-lg"
          style="max-width: 749px"
        >
          <legend class="text-left text-h6">
            Housing Accommodations for Disability
          </legend>
          <q-separator />
          <div
            class="text-left text-body1 q-gutter-md"
          >
            <div>
              If you have a disability and would like to request housing accommodations,
              click the checkbox to affirm your interest below. This checkbox will
              additionally open a new tab to the
              “<a href="https://www.digipen.edu/student-portal/student-services/disability-support-services/requesting-housing-accommodations">
                Housing Accommodations Page</a>”
              of our website where you can find the following information:
            </div>
            <div>
              <ul>
                <li>
                  A description of what housing accommodations are
                </li>
                <li>
                  Step-by-step instructions on how to submit your request
                </li>
                <li>
                  Link to the Disability Verification Form for Housing Accommodation Request
                </li>
              </ul>
            </div>
            <div>
              Return to this page to complete your housing application, and
              later please review the page and begin the request process.
              This process helps ensure your housing needs are reviewed
              and supported by the Disability Support Services (DSS) team.
            </div>
          </div>
          <div class="q-gutter-md row items-start">
            <q-checkbox
              v-model="applicationDetails.dssAccessible"
              @update:model-value="applicationDetails.dssAccessible == 'Requested'
              ? goToDssSite(): ''"
              class="text-left col-12"
              label="I am a person with a disability and would
              like to request housing accommodations related to my disability."
              :true-value="'Requested'"
              :false-value="'Waived'"
            />
          </div>
        </fieldset>
        <fieldset class="q-gutter-md"
                  style="max-width: 749px">
          <legend class="text-left text-h6">
            Bedroom and Apartment Preferences
          </legend>
          <q-separator />

          <legend class="text-left text-body1 q-pl-md">
            <div v-if="roomRateTableCount > 2">
              Please indicate below your top two Room Type preferences.
            </div>
            <div v-else>
              Please indicate below your top Room Type preference.
            </div>
            <span class="text-weight-bold text-body2">
              *Note that prices listed are billed per semester
            </span>
          </legend>

          <div class="q-gutter-md row items-start">
            <q-select v-model.trim="applicationDetails.apartmentPreference1"
                      label="Room Type Preference 1 *"
                      :options="roomRateTablesOptions"
                      @filter='roomRateTablesFilter'
                      behavior="menu"
                      style="width: 300px"
                      :rules="[checkSelect]"
                      lazy-rules />
            <q-select v-if="roomRateTableCount > 2"
                      v-model.trim="applicationDetails.apartmentPreference2"
                      label="Room Type Preference 2 *"
                      :options="roomRateTablesOptions"
                      @filter='roomRateTablesFilter'
                      behavior="menu"
                      style="width: 300px"
                      :rules="[checkSelect]"
                      lazy-rules />
          </div>

          <div class="text-left text-body1 q-gutter-md">
            <div>
              Please indicate below if you would like to live with
              roommates with the same academic degree as you or different academic degree as you:
            </div>
          </div>
          <div class="flex flex-left q-pa-md row">
            <q-radio v-model="applicationDetails.roommatesHaveSameDegree"
                    class="col-12 q-ml-md"
                    :val="true"
                    label="Same Academic Degree" />
            <q-radio v-model="applicationDetails.roommatesHaveSameDegree"
                    class="col-12 q-ml-md"
                    :val="false"
                    label="Any Academic Degree" />
          </div>

          <div class="text-left text-body1 q-gutter-md">
            DigiPen Housing may provide approved housing
            accommodationsto students with disabilities
            through partnership with the Disability Support
            Services (DSS) office including but not
            limited to: accommodating a student to have a
            DSS Approved Emotional Support Animal (ESA)
            or Service Animal live with them within DigiPen Housing.
          </div>
          <div class="flex flex-left q-pa-md row">
            <q-radio v-model="applicationDetails.roommatesHaveEmotionalSupportAnimal"
                    class="col-12 q-ml-md text-left"
                    :val="true"
                    label="I am willing to share an apartment
                    space with an approved ESA or Service Animal" />
            <q-radio v-model="applicationDetails.roommatesHaveEmotionalSupportAnimal"
                    class="col-12 q-ml-md text-left"
                    :val="false"
                    label="I am unable to share an apartment space with an approved
                    ESA or Service Animal due to concerns for my personal physical
                    health. (i.e., severe allergies, or phobia)" />
          </div>
        </fieldset>
        <fieldset
          class="flex-left q-gutter-md"
          style="max-width: 749px; width: 749px"
        >
          <legend class="text-left text-h6">
              Roommate Preferences

            <q-icon class="cursor-pointer"
                    color="positive"
                    size="sm"
                    name="help_outline">
              <q-tooltip class="text-body2"
                          max-width="377px"
                          anchor="top middle"
                          self="bottom middle"
                          :offset="[10, 10]">
                <div class="q-ma-sm">
                  Please note that your request for a specific
                  roommate may or may not be granted due to
                  availability of space or other factors within the placement process.
                </div>
                <div class="q-ma-sm">
                  Roommate preferences are prioritized by our
                  application in the order listed. Please
                  list your roommate preferences accordingly (1 being the most important preference)
                </div>
                <div class="q-ma-sm">
                  Please ensure that you list DigiPen email
                  of your requested roommates correctly, as
                  the matching function of our application will not work properly if not.
                </div>
              </q-tooltip>
            </q-icon>
          </legend>
          <q-separator />
          <div class="q-gutter-md row items-start">
            <q-checkbox
              v-model="hasPreferredRoommates"
              class="text-left"
              label="Do you have someone or a group of people in mind that
                you want to live with?"
            />
            <!-- <q-icon
              class="cursor-pointer q-pt-sm"
              color="positive"
              size="sm"
              name="help_outline"
            >
              <q-tooltip
                class="text-body2"
                max-width="377px"
                anchor="top middle"
                self="bottom middle"
                :offset="[10, 10]">
                <div class="q-ma-sm">
                  If you have indicated your interest in the Rainbow LLC,
                  please note that you and your requested roommate must
                  both be accepted to RAINBOW for this request to be honored.
                </div>
              </q-tooltip>
            </q-icon> -->
          </div>
          <div
            v-if="hasPreferredRoommates"
            transition="expand"
            class="q-gutter-md"
          >
            <div
              class="text-left text-body1"
            >
              Please list their DigiPen email(s) below:
            </div>
            <div class="row items-start q-gutter-md">
              <q-input
                v-model="applicationDetails.preferredRoommateDigipenEmail1"
                :rules="[checkIsValidEmailOrEmpty]"
                lazy-rules
                label="DigiPen Email 1"
                type="email"
                style="width: 300px"
              />
              <q-input
                v-model="applicationDetails.preferredRoommateDigipenEmail2"
                :rules="[checkIsValidEmailOrEmpty]"
                lazy-rules
                label="DigiPen Email 2"
                type="email"
                style="width: 300px"
              />
            </div>
            <div class="row items-start q-gutter-md">
              <q-input
                v-model="applicationDetails.preferredRoommateDigipenEmail3"
                :rules="[checkIsValidEmailOrEmpty]"
                lazy-rules
                label="DigiPen Email 3"
                type="email"
                style="width: 300px"
              />
              <q-input
                v-model="applicationDetails.preferredRoommateDigipenEmail4"
                :rules="[checkIsValidEmailOrEmpty]"
                lazy-rules
                label="DigiPen Email 4"
                type="email"
                style="width: 300px"
              />
            </div>
          </div>
        </fieldset>
        <fieldset
          class="flex-center q-gutter-md q-mt-lg"
          style="max-width: 749px; width: 749px"
        >
          <legend class="text-left text-h6">
            Vehicle Information
          </legend>
          <q-separator />
          <div class="q-gutter-md row items-start">
            <q-checkbox
              v-model="hasVehicle"
              class="text-left"
              label="Will you be bringing a vehicle with you to DigiPen housing?"
            />
            <q-icon
              class="cursor-pointer q-pt-sm"
              color="positive"
              size="sm"
              name="help_outline"
            >
              <q-tooltip
                class="text-body2"
                max-width="377px"
                anchor="top middle"
                self="bottom middle"
                :offset="[10, 10]">
                <div class="q-ma-sm">
                 Reserved or Covered parking is not guaranteed for all residents
                  each DigiPen apartment has one allocated reserved parking space.
                  Students who share the same DigiPen apartment are expected to
                  coordinate use of the space during their stay.
                </div>
                <div class="q-ma-sm">
                If the number of students with cars in the same apartment exceeds
                 the allocated reserved parking spaces - they must find “free”
                 parking in un-covered, un-marked parking spaces within the community.
                 If issues regarding the availability of parking arise, DigiPen
                 Housing may  allocate additional parking spaces, if possible.
                </div>
              </q-tooltip>
            </q-icon>
          </div>
          <div
            class="q-gutter-md row items-start"
            v-if="hasVehicle"
            transition="expand"
          >
            <div class="text-left text-body1">
              Please enter vehicle information below:
            </div>
            <div class="row items-start q-gutter-md">
              <q-input
                v-model="applicationDetails.vehicleMake"
                label="Vehicle Make *"
                style="width: 300px"
                :rules="[checkInput]"
                lazy-rules
              />
              <q-input
                v-model="applicationDetails.vehicleModel"
                label="Vehicle Model *"
                style="width: 300px"
                :rules="[checkInput]"
                lazy-rules
              />
            </div>
            <div class="row items-start q-gutter-md">
              <q-input
                v-model="applicationDetails.vehicleLicense"
                label="Vehicle License Plate Number *"
                style="width: 300px"
                :rules="[checkInput]"
                lazy-rules
              />
              <q-input
                v-model="applicationDetails.vehicleColor"
                label="Vehicle Color *"
                style="width: 300px"
                :rules="[checkInput]"
                lazy-rules
              />
            </div>
            <div class="row items-start q-gutter-md">
              <q-select
                v-model.trim="applicationDetails.vehicleState"
                label="Issuing State *"
                :options="statesOptions"
                behavior="menu"
                style="width: 300px"
                :rules="[checkSelect]"
                lazy-rules
              />
            </div>
          </div>
        </fieldset>
        <fieldset
          class="flex-center q-gutter-md q-mt-lg"
          style="max-width: 749px"
        >
          <legend class="text-left text-h6">
            My Tendencies
          </legend>
          <q-separator />
          <div
            class="text-left text-body1 q-gutter-md"
          >
            <div>
              Please check item below as it applies to you and your living habits:
            </div>
          </div>
          <div class="q-gutter-md row items-start">
            <q-checkbox
              v-model="applicationDetails.cleanlinessHabits"
              label="I would identify with having 'good' cleanliness habits. I strive to keep my
              space free of clutter & clean up after my messes soon after creating them."
              class="text-left col-12"
            />
            <q-checkbox
              v-model="applicationDetails.sharingHabits"
              label="I would be open to sharing agreed-upon
              items in the apartment with my housemates,
              such as but not limited to: personal appliances,
              cleaning supplies, and certain food items."
              class="text-left col-12"
            />
            <q-checkbox
              v-model="applicationDetails.socialHabits"
              label="I would consider myself a social person.
              I would like to talk often with my
              roommates, and have friends over to the apartment to hang-out."
              class="text-left col-12"
            />
            <q-checkbox
              v-model="applicationDetails.isMorningPerson"
              label="I would consider myself a “morning person”
              and am often awake before others are."
              class="text-left col-12"
            />
            <q-checkbox
              v-model="applicationDetails.isNightPerson"
              label="I would consider myself a “night owl” and am often up later than others are."
              class="text-left col-12"
            />
          </div>
        </fieldset>
      </q-form>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import useSession from '@/hooks/session';
import useApplication from '@/hooks/application';
import useUiUtilities from '@/utilities/uiUtilities';
import useUiValidations from '@/utilities/uiValidations';

export default {
  methods: {
    async onSubmit() {
      const success = await this.$refs.applicationPreferenceForm.validate();
      if (success) {
        this.$emit('CheckIfFormIsValid', true);
      } else {
        this.$emit('CheckIfFormIsValid', false);
      }
    },
  },
  async setup() {
    const { sessionDetails, getPreviouslyPlaced } = useSession();
    const { applicationDetails, hasVehicle } = useApplication();
    const { statesOptions } = useUiUtilities();
    const {
      checkInput,
      checkIsRoommateValid,
      checkIsValidEmailOrEmpty,
      checkSelect,
    } = useUiValidations();

    const apartmentPreferenceOptions = ref([]);
    const roomRateTablesOptions = ref([]);
    // const roommatesGendersModel = ref([]);
    const roomRateTableCount = sessionDetails.value.unitTypes.length;

    const previouslyPlaced = getPreviouslyPlaced();

    const roomRateTablesFilter = (val, update) => {
      update(() => {
        apartmentPreferenceOptions.value = [
          applicationDetails.value.apartmentPreference1,
          applicationDetails.value.apartmentPreference2,
        ];
        roomRateTablesOptions.value = sessionDetails.value.unitTypes
          .filter((roomRateClass) => !apartmentPreferenceOptions.value.includes(roomRateClass));
      });
    };

    const goToDssSite = () => {
      if (sessionDetails.value.dssUri) {
        window.open(sessionDetails.value.dssUri);
      }
    };

    const goToLlcSite = () => {
      if (sessionDetails.value.llcUri) {
        window.open(sessionDetails.value.llcUri);
      }
    };

    const genderList = ref([]);

    for (let i = 0; i < sessionDetails.value.genderOptions.length; i += 1) {
      genderList.value.push(sessionDetails.value.genderOptions[i].sessionOption);
    }

    const populateSecondApartmentPreference = () => {
      if (roomRateTableCount <= 2) {
        apartmentPreferenceOptions.value = [
          applicationDetails.value.apartmentPreference1,
        ];
        const [secondValue] = sessionDetails.value.unitTypes
          .filter((roomRateClass) => !apartmentPreferenceOptions.value.includes(roomRateClass));

        applicationDetails.value.apartmentPreference2 = secondValue;
      }
    };

    const clearRoommatesGendersIfNotOther = () => {
      if (applicationDetails.value.liveWithSameGenders !== 'Other') {
        applicationDetails.value.roommatesGenders = [];
      }
    };

    const checkIsEmptyGenderList = () => {
      if (applicationDetails.value.roommatesGenders === null) {
        return 'Please make selection(s)';
      }

      return applicationDetails.value.roommatesGenders.length !== 0 || 'Please make selection(s)';
    };

    onMounted(() => {
      if (roomRateTableCount <= 2) {
        applicationDetails.value.apartmentPreference2 = '';
      }
    });

    onBeforeUnmount(() => {
      populateSecondApartmentPreference();
      clearRoommatesGendersIfNotOther();
    });

    return {
      genderList,
      goToDssSite,
      goToLlcSite,
      checkInput,
      checkIsEmptyGenderList,
      checkIsRoommateValid,
      checkIsValidEmailOrEmpty,
      checkSelect,
      previouslyPlaced,
      sessionDetails,
      applicationDetails,
      apartmentPreferenceOptions,
      statesOptions,
      hasVehicle,
      hasPreferredRoommates: ref(false),
      // roommatesGendersModel,
      roomRateTableCount,
      roomRateTablesOptions,
      roomRateTablesFilter,
    };
  },
};
</script>

<style>
/* always present */
.expand-transition {
  transition: all 0.3s ease;
  height: 30px;
  padding: 10px;
  background-color: #eee;
  overflow: hidden;
}
/* .expand-enter defines the starting state for entering */
/* .expand-leave defines the ending state for leaving */
.expand-enter,
.expand-leave {
  height: 0;
  padding: 0 10px;
  opacity: 0;
}
</style>
